export default __webpack_public_path__ + "static/media/life3.e6cecc1f.png";